import React from "react";

interface CirclePlusIconProps {
  className?: string;
  size?: number;
}

export const CirclePlusIcon = ({
  className = "",
  size = 40,
}: CirclePlusIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M19.0143 27.9167H21.1081V21.1259H27.916V19.0322H21.1081V12.0834H19.0143V19.0322H12.0827V21.1259H19.0143V27.9167ZM20.0093 35.8334C17.8174 35.8334 15.762 35.4179 13.8431 34.5868C11.9239 33.7556 10.247 32.6231 8.81226 31.1892C7.37776 29.7551 6.24476 28.0783 5.41309 26.1588C4.58171 24.2391 4.16602 22.1824 4.16602 19.9888C4.16602 17.8024 4.58157 15.7473 5.41268 13.8234C6.24379 11.8992 7.37629 10.2245 8.81018 8.79919C10.2443 7.37402 11.9212 6.24552 13.8406 5.41385C15.7603 4.58236 17.817 4.16669 20.0106 4.16669C22.197 4.16669 24.2521 4.58224 26.176 5.41335C28.1002 6.24446 29.7749 7.37238 31.2002 8.79719C32.6255 10.2219 33.7539 11.8973 34.5856 13.8234C35.417 15.7495 35.8327 17.8051 35.8327 19.9901C35.8327 22.182 35.4171 24.2374 34.586 26.1563C33.7549 28.0755 32.627 29.7506 31.2023 31.1817C29.7775 32.6131 28.1021 33.7462 26.176 34.5809C24.2499 35.4159 22.1943 35.8334 20.0093 35.8334ZM20.0131 33.7392C23.8314 33.7392 27.0737 32.4034 29.7398 29.7317C32.4056 27.0601 33.7385 23.8116 33.7385 19.9863C33.7385 16.168 32.4073 12.9258 29.7448 10.2597C27.0823 7.59385 23.8338 6.26085 19.9993 6.26085C16.1832 6.26085 12.9393 7.59219 10.2677 10.2547C7.59601 12.9172 6.26018 16.1656 6.26018 20.0001C6.26018 23.8162 7.59601 27.0601 10.2677 29.7317C12.9393 32.4034 16.1878 33.7392 20.0131 33.7392Z"
      fill="currentColor"
    />
  </svg>
);
